<script setup lang="ts">
import VerbInflectionSchemeModal from "@/components/article/dictsys/inflectionSchemes/german/VerbInflectionSchemeModal.vue";
import InflectionSchemeCellPlaceholder from "@/components/inflectionTrainer/InflectionSchemeCellPlaceholder.vue";
import { makeInflectionCell } from "@/helpers/dictsys-inflection-scheme/inflection-scheme.helper";
import type {
  DictsysInflectionSchemeGermanVerbMood,
  DictsysInflectionSchemeGermanVerbPerson
} from "@/types";

const makeTenseInflections = (
  first_person_singular: string,
  second_person_singular: string,
  third_person_it_singular: string,
  first_person_plural: string,
  second_person_plural: string,
  third_person_plural: string
): DictsysInflectionSchemeGermanVerbPerson => ({
  first_person_singular: makeInflectionCell("", first_person_singular),
  second_person_singular: makeInflectionCell("", second_person_singular),
  third_person_he_singular: makeInflectionCell("", third_person_it_singular),
  third_person_she_singular: makeInflectionCell("", third_person_it_singular),
  third_person_it_singular: makeInflectionCell("", third_person_it_singular),
  first_person_plural: makeInflectionCell("", first_person_plural),
  second_person_plural: makeInflectionCell("", second_person_plural),
  third_person_plural: makeInflectionCell("", third_person_plural)
});

const inflectionScheme: DictsysInflectionSchemeGermanVerbMood = {
  indicative: {
    present: makeTenseInflections("", "", "", "", "", ""),
    simple_past: makeTenseInflections("", "", "", "", "", ""),
    future: makeTenseInflections("werde", "wirst", "wird", "werden", "werdet", "werden")
  },
  perfect_tenses: {
    present_perfect: makeTenseInflections(
      "bin/habe",
      "bist/hast",
      "ist/hat",
      "sind/haben",
      "seid/habt",
      "sind/haben"
    ),
    past_perfect: makeTenseInflections(
      "war/hatte",
      "warst/hattest",
      "war/hatte",
      "waren/hatten",
      "wart/hattet",
      "waren/hatten"
    )
  }
};
</script>

<template>
  <VerbInflectionSchemeModal :inflection-scheme="inflectionScheme">
    <template #inflection-cell="{ inflections }">
      <InflectionSchemeCellPlaceholder v-if="inflections.length > 0" :inflection="inflections[0]" />
    </template>
  </VerbInflectionSchemeModal>
</template>
